import React, {Fragment} from 'react';

import {AlertActions, AlertModal} from 'presentation/components';
import {Drawer} from 'presentation/components/Drawer';
import {useMediaQueries} from 'presentation/pages/private/hooks';
import {translations} from 'presentation/translations-new';
import {OrientationsTexts} from './components/OrientationsTexts';
import {SurgeryPrepareOrientationsProps} from './types';

const {agreementText} = translations['pt-br'].commons;
const {headerTitle} =
	translations['pt-br'].privateFlow.myAppointments.myAppointmentsList.surgeryOrientations;

export function SurgeryPrepareOrientations({open, setOpen}: SurgeryPrepareOrientationsProps) {
	const {isMobile} = useMediaQueries();

	return (
		<Fragment>
			{isMobile ? (
				<Drawer.Root
					open={open}
					onClose={() => setOpen(false)}
					onOpen={() => setOpen(true)}
					width="396px"
					customMaxHeight="100%"
					sx={{zIndex: 9000}}>
					<Drawer.Header onClose={() => setOpen(false)} title={headerTitle} />
					<Drawer.Content mt={isMobile ? 0 : 1.5} gap={1} mb={1}>
						<OrientationsTexts />
					</Drawer.Content>
					<Drawer.Footer
						hideFirstButton
						secondButtonTitle={agreementText}
						secondButtonOnClick={() => setOpen(false)}
					/>
				</Drawer.Root>
			) : (
				<AlertModal
					customContentStyles={{
						alignItems: 'flex-start',
					}}
					showIcon={false}
					footerContent={
						<AlertActions
							primaryAction={() => setOpen(false)}
							primaryText={agreementText}
							flexDirection="column"
						/>
					}
					headerTitle={headerTitle}
					open={open}
					variant="primary"
					onClose={() => setOpen(false)}
					subDescription={<OrientationsTexts />}
				/>
			)}
		</Fragment>
	);
}
